import ExistsFilterParser from './parsers/exists-filter-parser';
import IsBetweenFilterParser from './parsers/is-between-filter-parser';
import IsFilterParser from './parsers/is-filter-parser';
import IsOneOfFilterParser from './parsers/is-one-of-filter-parser';
import lookupFilterParser from './parsers/lookup-filter-parser';
import MatchFilterParser from './parsers/match-filter-parser';
export const KibanaFilterParsers = [
    new IsFilterParser(),
    new IsBetweenFilterParser(),
    new IsOneOfFilterParser(),
    new ExistsFilterParser(),
    new MatchFilterParser(),
];
export const CustomFilterParsers = [lookupFilterParser];
export const SupportedElasticKeys = KibanaFilterParsers.map((parser) => parser.elasticKey);
export const CustomElasticKeys = CustomFilterParsers.map((parser) => parser.elasticKey);
//# sourceMappingURL=osd-filter-parsers.js.map